import {FC} from "react";
import {Box} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import {AdminUserPage} from "./AdminUserPage";
import {AdminUsersList} from "./AdminUsersList/AdminUsersList";

/**
 * Admin Users Page Wrapper
 *
 * Routes between:
 * - /admin/users → User list (App2: server-side pagination, sort, filter)
 * - /admin/users/:id/* → Individual user page with tabs
 */
export const AdminUsersPage: FC = () => {
	return (
		<Box>
			<Routes>
				<Route index element={<AdminUsersList />} />
				<Route path=":id/*" element={<AdminUserPage />} />
			</Routes>
		</Box>
	);
};

